module.exports = __webpack_public_path__ + "img/wechat.a2eb9e7a.png";